import translations from './translations'

translations.add('es', {
    headerMessage: '¿Ya pagaste usando tu app bancaria?',
    no: 'No',
    yes: 'Sí'
})
